import React from "react";
import { Route } from "react-router-dom";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

export const PrivateRoute = ({ component: Component, ...props }) => {
  const uiConfig = {
    signInFlow: "popup",
    signInOptions: [props.firebase.auth.GoogleAuthProvider.PROVIDER_ID],
    callbacks: {
      signInSuccessWithAuthResult: () => false
    }
  };

  return (
    <Route
      {...props}
      render={innerProps =>
        props.isSignedIn &&
        props.currentUser &&
        props.currentUser.email.match(
          /(@floorforce.com|@broadlume.com|@tryadhawk.com)$/
        ) ? (
          <Component {...innerProps} />
        ) : (
          <StyledFirebaseAuth
            className="firebase-auth--button"
            uiConfig={uiConfig}
            firebaseAuth={props.firebase.auth()}
          />
        )
      }
    />
  );
};
